// @flow

import React from 'react';
import Chip from '@material-ui/core/Chip';

import type { TypePropsManufacturersAlias } from 'stores/ManufacturersProductsStore';

import styles from './ChipList.module.scss';

export type ChipListItem = {
  label: string,
};

export type ChipListProps = {
  chips: ChipListItem[],
};
export default class ChipList extends React.PureComponent<ChipListProps> {
  render() {
    const { chips } = this.props;

    return (
      <div className={styles['chips-wrapper']}>
        {chips.map(aliasItem => (
          <Chip key={aliasItem.label} label={aliasItem.label} />
        ))}
      </div>
    );
  }
}
